import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useOffer } from '../contexts/OfferContext';
import { offerConfig, urgencyConfig } from '../data/siteConfig';
import { useRemoteNumber } from '../hooks/useRemoteNumber';
import { useToday } from '../hooks/useToday';
const DAYS = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
export const UrgencySection = () => {
  const {
    secondsLeft,
    expired,
    priceLabel,
    nextPriceLabel
  } = useOffer();
  const today = useToday();
  const cupos = useRemoteNumber(urgencyConfig.cuposEndpoint, urgencyConfig.cuposDisponiblesHoy);
  const viewers = useRemoteNumber(urgencyConfig.activeViewersEndpoint, 0);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const cuposValue = Math.max(0, Math.min(cupos.value, urgencyConfig.totalCupos));
  const cuposPct = Math.round(cuposValue / urgencyConfig.totalCupos * 100);
  const ddmm = `${pad(today.getDate())}/${pad(today.getMonth() + 1)}`;
  return <section id="precio-lanzamiento" className="bg-familia-dark border-t border-familia-darkBorder py-12 md:py-16 px-4 md:px-6" data-id="element-262" data-mp="2sufw6ero1qsl">
      <div className="max-w-3xl mx-auto text-center w-full" data-id="element-263" data-mp="2xtak1v4hq5jk">
        <div className="max-w-xl mx-auto bg-familia-darkCard border-2 border-familia-darkBorder p-6 md:p-8 rounded-2xl" data-id="element-264" data-mp="32rkiqfpfbo9x">
          <h2 className="text-white font-bold text-[26px] uppercase tracking-wide leading-snug mb-6" data-id="element-265" data-mp="37jcct07sgc4t">
            Oferta de hoy ·{' '}
            <span className="text-familia-accent" data-id="element-266" data-mp="3ck00pd0q0cut">{DAYS[today.getDay()]}</span>
          </h2>

          <div className="bg-familia-dark border border-familia-darkBorder rounded-xl p-4 md:p-5 mb-6" data-id="element-267" data-mp="3glbrvmz8t654">
            <p className="text-body text-familia-onDarkMuted" data-id="element-268" data-mp="3lgirailhboo8">
              Tu precio de lanzamiento queda reservado por{' '}
              <span className="font-bold text-white" data-id="element-269" data-mp="1r4u987jyb5zm">
                {offerConfig.reservationMinutes} minutos
              </span>
              . Si vence, el kit vuelve a{' '}
              <span className="font-bold text-white" data-id="element-270" data-mp="1o2ps0569rbvv">{nextPriceLabel}</span>.
            </p>
          </div>

          {expired ? <div role="status" className="border-2 border-familia-urgent rounded-xl px-5 py-5 mb-4" data-id="element-271" data-mp="1k1mcjjs4vhv6">
              <p className="text-familia-urgent font-bold text-2xl uppercase tracking-wider" data-id="element-272" data-mp="1y1ezr54gbfye">
                Tu reserva venció
              </p>
              <p className="text-body text-familia-onDarkMuted mt-1" data-id="element-273" data-mp="1t0hiqvv6gryh">
                El precio actual es{' '}
                <span className="font-bold text-white" data-id="element-274" data-mp="26zh7s4mlr8v6">{priceLabel}</span>.
              </p>
            </div> : <>
              <p className="text-familia-urgent font-bold text-[14px] sm:text-[15px] uppercase tracking-widest mb-4" data-id="element-275" data-mp="2grdiqg9setgt">
                Tu reserva vence en:
              </p>
              <div className="flex justify-center items-start gap-3 sm:gap-4 mb-4" role="timer" aria-live="off" data-id="element-276" data-mp="2bt27c13ugawh">
                {[{
              value: minutes,
              label: 'MINUTOS'
            }, {
              value: seconds,
              label: 'SEGUNDOS'
            }].map(unit => <div key={unit.label} className="bg-familia-dark border-2 border-familia-urgent/60 rounded-xl px-5 sm:px-7 py-3 sm:py-4 min-w-[100px] sm:min-w-[120px]" data-id="element-277" data-mp="35crnnber0ymk">
                    <div className="font-mono text-familia-urgent text-4xl sm:text-5xl font-bold leading-none tabular-nums" data-id="element-278" data-mp="2veveuq9aafrm">
                      {pad(unit.value)}
                    </div>
                    <div className="text-familia-onDarkMuted text-[12px] sm:text-[13px] font-bold uppercase tracking-widest mt-2" data-id="element-279" data-mp="2lnqypn7vgov7">
                      {unit.label}
                    </div>
                  </div>)}
              </div>
            </>}

          <p className="text-[15px] sm:text-[16px] text-familia-onDarkMuted mb-6" data-id="element-280" data-mp="2cpfb7u2ay76z">
            Precio de lanzamiento válido hasta el{' '}
            <span className="font-bold text-white" data-id="element-281" data-mp="22poinxxay29j">{ddmm}</span> a las 23:59.
          </p>

          <div className="border-t border-familia-darkBorder pt-5 mb-5 text-left" data-id="element-282" data-mp="27ohttjp49h6j">
            <div className="flex items-baseline justify-between gap-3 mb-2" data-id="element-283" data-mp="27qc6kaq8i2zj">
              <span className="text-[14px] sm:text-[15px] font-semibold text-familia-onDarkMuted" data-id="element-284" data-mp="3aylxygs26rjm">
                Cupos con precio de lanzamiento hoy:
              </span>
              <span className="text-[15px] sm:text-[16px] font-bold text-familia-urgent whitespace-nowrap" data-id="element-285" data-mp="318kanr7j5d5r">
                {cuposValue} de {urgencyConfig.totalCupos}
              </span>
            </div>
            <div className="w-full bg-familia-urgent/15 h-3 rounded-full overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={urgencyConfig.totalCupos} aria-valuenow={cuposValue} aria-label="Cupos con precio de lanzamiento disponibles hoy" data-id="element-286" data-mp="2rc7gytbzizb0">
              <div className="bg-familia-urgent h-full rounded-full transition-[width] duration-300 ease-out" style={{
              width: `${cuposPct}%`
            }} data-id="element-287" data-mp="2dbn0w4xgfhl7" />
            </div>
          </div>

          {viewers.isLive ? <div className="flex items-center justify-center gap-2" data-id="element-288" data-mp="bk0dsegoo6u0">
              <span className="w-2.5 h-2.5 bg-familia-urgent rounded-full animate-blink" aria-hidden="true" data-id="element-289" data-mp="j3stss9e37hs" />
              <span className="text-[15px] sm:text-[16px] text-familia-onDarkMuted" data-id="element-290" data-mp="o2mccz3j9oot">
                <span className="font-bold text-white" data-id="element-291" data-mp="stm5rudg1omk">
                  {viewers.value} personas
                </span>{' '}
                están viendo esta página ahora
              </span>
            </div> : urgencyConfig.descargasEstaSemana === null ? null : <div className="flex items-center justify-center gap-2" data-id="element-292" data-mp="68fgf493rbf">
              <CheckIcon className="w-4 h-4 text-familia-checkDark shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-293" data-mp="53i3prfwlwxo" />
              <span className="text-[15px] sm:text-[16px] text-familia-onDarkMuted" data-id="element-294" data-mp="a233xqv5ogm4">
                <span className="font-bold text-white" data-id="element-295" data-mp="f2qwigz195ig">
                  {urgencyConfig.descargasEstaSemana} familias
                </span>{' '}
                lo descargaron esta semana
              </span>
            </div>}
        </div>
      </div>
    </section>;
};
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}